export type Locale = "en" | "id";

export const DEFAULT_LOCALE: Locale = "en";
export const LOCALE_COOKIE = "nebula-locale";

export function isLocale(value: string | undefined | null): value is Locale {
  return value === "en" || value === "id";
}

/** Picks the highest-weighted supported locale from a raw Accept-Language
    header value (e.g. "fr,id;q=0.5,en;q=0.3" -> "id"), skipping any
    unsupported language even if it's listed first or weighted higher.
    Returns null if nothing supported is found, so callers can fall back
    to DEFAULT_LOCALE. */
export function parseAcceptLanguage(header: string | null | undefined): Locale | null {
  if (!header) return null;

  const ranked = header
    .split(",")
    .map((entry) => {
      const [rawTag, ...params] = entry.trim().split(";");
      const tag = rawTag.trim().split("-")[0].toLowerCase();
      const qParam = params.map((p) => p.trim().toLowerCase()).find((p) => p.startsWith("q="));
      const parsedQ = qParam ? Number.parseFloat(qParam.slice(2)) : 1;
      const q = Number.isFinite(parsedQ) ? parsedQ : 0;
      return { tag, q };
    })
    .filter(({ q }) => q > 0)
    .sort((a, b) => b.q - a.q);

  for (const { tag } of ranked) {
    if (isLocale(tag)) return tag;
  }
  return null;
}
